import React from "react";

import { UpdateParameterValues } from "../services/City";
function SaleCost(props) {
  const [value, setValue] = React.useState(null);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [IsReadOnly, SetReadOnly] = React.useState(false);
  React.useEffect(() => {
    console.log(props)

    var structuretype = props.structureType;
    if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 287 && item.structureType == props.structureType).value == 'true') {
      document.getElementById("row-" + structuretype + "-198").style.display = "none";
      document.getElementById("row1-" + structuretype + "-198").style.display = "none";
      document.getElementById("row-" + structuretype + "-229").style.display = "none";

      document.getElementById("row-" + structuretype + "-201").style.display = "none";

    }
    if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 288 && item.structureType == props.structureType).value == 'true') {

      document.getElementById("row-" + structuretype + "-110").style.display = "none";
      document.getElementById("row1-" + structuretype + "-110").style.display = "none";
      document.getElementById("row-" + structuretype + "-99").style.display = "none";


      document.getElementById("row-" + structuretype + "-239").style.display = "none";
    }
    if (props.isSite == 0) {
      SetReadOnly(true);
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.id == 260 || props.id == 261 || props.id == 262 || props.id == 140 || props.id == 252 || props.id == 3252 || props.id == 254 || props.id == 3254 || props.id == 258 || props.id == 257) {

      SetStyle("form-control construction ");

    }
    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.id == 255 || props.id == 3255) {

      SetStyle("form-control  Prowidth2 RightTop");

    }
    if (props.id == 278 || props.id == 279) {

      SetStyle("form-control  Prowidth2 ");

    }
    if (props.id == 256 || props.id == 3256) {

      SetStyle("form-control construction leftTop leftBottom");

    }
    if ((props.id == 258 || props.id == 69 || props.id == 3258 || props.id == 369) && (props.structureType != "Single Family")) {

      SetStyle("form-control construction RightTop RightBottom ");

    }
    if (((props.id == 258 || props.id == 3258) && props.structureType == "Single Family")) {

      SetStyle("form-control construction  RightBottom ");

    }
    if (((props.id == 36 || props.id == 336) && props.structureType == "Single Family")) {

      SetStyle("form-control construction  leftBottom ");

    }
    if ((props.id == 249 || props.id == 3249)) {

      SetStyle("form-control construction leftTop");

    }

    if (props.id == 250 || props.id == 3250) {

      SetStyle("form-control construction RightTop ");

    }
    if (props.id == 247 || props.id == 3247) {

      SetStyle("form-control construction leftBottom");

    }
    if (props.id == 140) {

      SetStyle("form-control construction RightBottom ");

    }
    if (props.id == 134) {

      SetStyle("form-control construction  leftBottom");

    }
    if (props.id == 248) {

      SetStyle("form-control construction RightBottom RightTop");

    }
    if (props.id == 41) {

      SetStyle("form-control construction  leftTop");

    }


  }, []);

  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    UpdateParameterValues(structuretype, props);
  }

  if (props.id == 191) {
    return (
      <>

        <div class="col-md-12">
          <div class="row" >
            <div class="col-md-9 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-2 col test1">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                readOnly
                class={IsStyle}
                style={{ borderRadius: "5px", marginBottom: "5px", paddingLeft: "2em" }}
              /></div></div>
        </div>
      </>
    );
  }
  if (props.id == 194) {
    return (
      <>
        <div class="col-md-2 col-2">
          <div class="row ml-2 test">
            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}

              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px", fontWeight: "550" }}
            /></div></div>

      </>
    );
  }
  if (props.id == 152) {
    return (
      <>
        <div class="col-md-9 col-9">
          <div class="row">
            <div class="col-md-9 col"> <label class="mr-1">{props.name.split('Per')[0]}
            </label></div>
            <div class="col-md-3 col-5"><div class="row test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}

              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px", fontWeight: "550" }}
            /></div></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 193) {
    return (
      <>
        <div class="col-md-2 col-2">
          <div class="row ml-2 test">
            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              readOnly
              class={IsStyle}

              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>

      </>
    );
  }
  if (props.id == 78) {
    return (
      <>
        <div class="col-md-9 col-9">
          <div class="row">
            <div class="col-md-9 col"> <label class="mr-1">{props.name.split('Per')[0]}
            </label></div>
            <div class="col-md-3 col-5"><div class="row test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              readOnly
              class={IsStyle}
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 192) {
    return (
      <>

        <div class="col-md-2 col-2" >
          <label class="d-block text center" style={{ width: "100%", textAlign: "center" }}>Apartment
          </label>
          <div class="row ml-2 test">
            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}

              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>

      </>
    );
  }
  if (props.id == 132) {
    return (
      <>
        <div class="col-md-9 col-9">
          <div class="row">
            <div class="col-md-9 col"> <label class="mr-1 mt-11" style={{ marginTop: "10%" }}>{props.name.split('Per')[0]}
            </label></div>
            <div class="col-md-3 col-5"><label class="d-block" style={{ textAlign: "center" }}>Per Unit
            </label><div class="row test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}

              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 74) {
    return (
      <>
        <div class="col-md-5 ">
          <div class="row">
            <div class="col-md-6 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-4 col col test1"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              readOnly
              class={IsStyle}
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 131) {
    return (
      <>
        <div class="col-md-6">
          <div class="row" style={{ textAlign: "left", marginLeft: "0%" }}>
            <div class="col-md-8 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-4 col test"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}

              class={IsStyle}
              readOnly
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 76) {
    return (
      <>
        <div class="row " style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "110%", marginBottom: "10%", marginTop: "0%" }}></div>

        <div class="col-md-5">
          <div class="row">
            <div class="col-md-6 col"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-4  col test1"> <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              readOnly
              class={IsStyle}
              style={{ borderRadius: "5px", marginBottom: "5px" }}
            /></div>
          </div>

        </div>
      </>
    );
  }
  if (props.id == 72) {
    return (
      <>
        <div class="col-md-4 col" style={{ marginTop: "-5%" }}>
          <div class="row" style={{ marginLeft: "-15px", marginRight: "-15px" }}>

            <div class="col-md-5 col" style={{ marginTop: "10%" }}> <label class="mr-1">Rent Per Unit
            </label></div>
            <div class="col-md-7 col" ><label class="d-block" style={{ textAlign: "center" }}>Monthly</label>
              <div class="test"> <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                readOnly
                class={IsStyle}
                style={{ borderRadius: "5px", marginBottom: "5px" }}
              /></div>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 73) {
    return (
      <>
        <div class="col-md-2 col-2" style={{ marginTop: "-5%" }}><label class="d-block" style={{ textAlign: "center" }}>Yearly</label>
          <div class="test"> <input
            type="text"
            key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id}
            value={value}
            onChange={onChange}

            class={IsStyle}
            readOnly
            style={{ borderRadius: "5px", marginBottom: "5px" }}
          />
          </div></div>
      </>
    );
  }
  if (props.id == 253 || props.id == 3253 || props.id == 39 || props.id == 3254 || props.id == 339 || props.id == 254) {
    if (props.id == 3253 || props.id == 253) {


      return (

        <>
          <div class="col-md-3" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 251 || props.id == 3251 || props.id == 38 || props.id == 338 || props.id == 252 || props.id == 3252) {
    if (props.id == 251 || props.id == 3251) {


      return (

        <>
          <div class="col-md-3" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 37 || props.id == 337 || props.id == 249 || props.id == 250 || props.id == 3250 || props.id == 3249) {
    if (props.id == 249 || props.id == 3249) {


      return (

        <>
          <div class="col-md-12 input-box1 ">
            <div class="row" style={{ width: "100%" }}>
              <div class="col-md-3"></div>
              <div class="col-md-2 col-2"><label class="d-block text-center">Per sqft </label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-3" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 369 || props.id == 3258 || props.id == 336 || props.id == 256 || props.id == 3256 || props.id == 36 || props.id == 258 || props.id == 69) {
    if (props.id == 3256 || props.id == 256) {
      if (props.structureType == "Single Family") {
        return (

          <>

            <div class="col-md-5" >
              <div class="from  justify-content-between  align-items-center ">
                <label class=""><u>Total Estimated Value</u>


                </label>



              </div>
            </div>
            <div class="col-2 ismobile"></div>
            <div class="col-md-2 col-2" style={{ display: "none" }}>
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>

          </>
        );
      }
      else {

        return (

          <>
            <div class="col-md-12 input-box1 mt-3">
              <div class="row" style={{ width: "100%" }}>
                <div class="col-md-3"></div>
                <div class="col-md-2 col-2"><label class="d-block text-center">Per sqft</label></div>
                <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
                <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
              </div></div>
            <div class="col-md-3" >
              <div class="from  justify-content-between  align-items-center ">
                <label class="">{props.name.split('Per')[0]}


                </label>



              </div>
            </div>

            <div class="col-md-2 col-2">
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }


    } else {
      if (props.structureType == "Single Family") {
        return (

          <>


            <div class="col-md-3 col-5" >
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (

          <>


            <div class="col-md-3 col-5" >
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
  if (props.id == 41 || props.id == 259 || props.id == 255 || props.id == 278 || props.id == 279 || props.id == 375) {
    if (props.id == 41) {


      return (

        <>
          <div class="col-md-12 input-box1 mt-3">
            <div class="row" style={{ width: "100%" }}>
              <div class="col-md-5 col"></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}


              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {
      if (props.id == 259) {
        return (

          <>


            <div class="col-md-2 col" >
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (

          <>


            <div class="col-md-1 col-2" >
              <div class="from  justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );

      }
    }
  }
  if (props.id == 43 || props.id == 260) {
    if (props.id == 43) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-2 col" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 44 || props.id == 261) {
    if (props.id == 44) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}


              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-2 col" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 42 || props.id == 262) {
    if (props.id == 42) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}


              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  if (props.id == 134 || props.id == 140) {
    if (props.id == 134) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class=""><u>{props.name.split('Per')[0]}</u>

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}
                  style={{ fontWeight: "550" }}
                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-5" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  readOnly
                  class={IsStyle}
                  style={{ fontWeight: "550" }}
                />
              </div>
            </div>
          </div>


        </>
      );
    }
  }
  if (props.id == 130 || props.id == 257) {
    if (props.id == 130) {


      return (

        <>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-2 col" >
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  else {

    return (
      <>
        <div class="col-md-3">
          <div class="from  justify-content-between  align-items-center ">
            <label class="">{props.name.split('Per')[0]}

            </label>



          </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from  justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                readOnly
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default SaleCost;
